'use client';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { useAppSelector } from '@/hooks/use-app-selector';
import { clientInstance } from '@/query/client-instance';
import { CUSTOMER_QUERY_KEY } from '@/query/query-keys';

const INTERNAL_CUSTOMER_ENDPOINT = 'customers';

export const useQueryCustomer = (
  currentCustomerId?: string,
  options: Omit<UseQueryOptions<MarketingCustomer | null, Error, MarketingCustomer | null>, 'queryKey'> = {}
) => {
  const authCustomerId = useAppSelector((state) => state.auth.user?.customerId);
  const customerId = currentCustomerId || authCustomerId;

  return useQuery<MarketingCustomer | null>({
    queryKey: [CUSTOMER_QUERY_KEY, customerId],
    enabled: Boolean(customerId),
    queryFn: async () => {
      const { data } = await clientInstance.get<MarketingCustomer>(`${INTERNAL_CUSTOMER_ENDPOINT}/${customerId}`);
      return data;
    },
    ...options
  });
};
